module.exports = __webpack_public_path__ + "img/cases_daqing.84fb9c04.jpg";